export default function Paragraph({content, limit}){

    return (
        <p className={`text-[14px] text-black text-opacity-50 ${limit}`}>
            {content}
        </p>
    )
}